import React, { useState, useEffect } from "react";
import {
  Text,
  VStack,
  Box,
  Link,
  Flex,
  Checkbox,
  Button,
  Tooltip,
} from "@chakra-ui/react";
import { layerStyle, textStyle } from "theme/names";
import { BiInfoCircle } from "react-icons/bi";
import { BiRefresh } from "react-icons/bi";
import { usePostCommentBox } from "./use-post-comment-box";

export const RetrieveComments = ({
  planType,
  postLimits = 5,
  commentFetchLimists = 30,
  username,
  idLinkedin,
  dashEntityUrn,
  isAuthenticated,
  isValidToken,
  idUser,
  isInfluentLeader = true,
  autoLike = false,
  onAutoLike,
}) => {
  const [nbCommentLimits, setNBCommentLimit] =
    useState<number>(commentFetchLimists);
  const [autoLikeLocal, setAutoLikeLocal] = useState<boolean>(false);
  const { isLoadingPosts, PostCommentBox, refreshPosts } = usePostCommentBox({
    postLimits,
    commentFetchLimists,
    username,
    idLinkedin,
    dashEntityUrn,
    isAuthenticated,
    isValidToken,
    idUser,
  })

  useEffect(() => {
    setNBCommentLimit(commentFetchLimists);
  }, [commentFetchLimists]);

  useEffect(() => {
    setAutoLikeLocal(autoLike);
  }, [isAuthenticated, autoLike]);

  return (
    <VStack alignContent="center" justifyContent="center" mb={9} w={"full"}>
      {!isLoadingPosts && (
        <>
          <Box>
            <Tooltip
              label={
                "Takes about 1 ~ 5 mins depending on the number of comments we need to fetch"
              }
              placement={"right"}
              hasArrow
              size="xs"
            >
              <Text
                textStyle={textStyle["body.medium.light"]}
                fontSize="md"
                textAlign={"center"}
              >
                Retrieves the last {nbCommentLimits} comments from your posts.{" "}
                <BiInfoCircle
                  style={{
                    display: "inline-block",
                    top: "3px",
                    position: "relative",
                  }}
                />
              </Text>
            </Tooltip>
          </Box>

          <Flex
            justifyContent={"end"}
            flexDirection={"column"}
            alignSelf={"end"}
          >
            <Box p="4" layerStyle={layerStyle["bg.border.rounded"]}>
              <Checkbox
                ml={1}
                onChange={async (e) => {
                  onAutoLike(autoLikeLocal);
                  setAutoLikeLocal(!autoLikeLocal);
                }}
                isChecked={autoLikeLocal}
              >
                auto-like post when replying
              </Checkbox>
            </Box>
            <Flex mt="3" alignSelf={"end"}>
              <Button
                variant="primary"
                ml={5}
                isDisabled={!isAuthenticated}
                leftIcon={<BiRefresh />}
                onClick={refreshPosts}
              >
                Refresh
              </Button>
            </Flex>
          </Flex>
        </>
      )}
      {planType != "enterprise" && !isLoadingPosts && (
        <Box>
          <Text
            textStyle={textStyle["body.medium.light"]}
            fontSize="md"
            textAlign={"center"}
          >
            <Link
              href={"/pricing"}
              title={"Update your plan to pro"}
              textDecoration={"underline"}
            >
              Upgrade to Pro
            </Link>{" "}
            to increase to 500 comments.
          </Text>
        </Box>
      )}
      <PostCommentBox />
    </VStack>
  );
};
